import { BehaviorSubject } from "rxjs";

import TWEEN from "@tweenjs/tween.js";
import { vec2, mat4 } from "gl-matrix";

import Sprite from "../sprite";
import { loadTexture } from "../helpers/webgl-helpers";

import spriteSheetImageUrl from "../../assets/sprites/military2.png";
import spriteSheetNormalImageUrl from "../../assets/sprites/military2-n.png";

import { Directions } from "../interfaces";

export default class Director extends Sprite {
  tileIndex: number;
  tileSize: vec2;
  tileSetDimensions: vec2;
  spriteAnimationTween: TWEEN.Tween;
  texture: WebGLTexture | null;
  textureUrl: string;
  normalTexture: WebGLTexture | null;
  animations: { [key: string]: number[] };
  animationName$: BehaviorSubject<string>;
  modelMatrix: number[];
  name: string;
  animationSpeed = 550;

  constructor(gl: WebGLRenderingContext, programName: string) {
    super(gl, programName);
    this.modelMatrix = <number[]>mat4.create();
    this.tileSize = [26, 36];
    this.tileSetDimensions = [312, 288];
    this.tileIndex = 0;
    this.textureUrl = spriteSheetImageUrl;
    this.name = "director";
    this.animations = {
      left: [63, 64, 65],
      up: [87, 88, 89],
      down: [51, 52, 53],
      right: [75, 76, 77],
      downIdle: [52],
      upIdle: [88],
      leftIdle: [64],
      rightIdle: [76]
    };
    this.setScale(this.tileSize[0] / this.tileSize[1], 1);
    this.setDirection(Directions.DownIdle);
  }

  async load() {
    const { gl } = this;
    this.texture = await loadTexture(gl, spriteSheetImageUrl);
    this.normalTexture = await loadTexture(gl, spriteSheetNormalImageUrl);
    return true;
  }
}
